<template>
  <section class="ViewPartners">
    <ul class="ViewPartners__list">
      <li class="ViewPartners__list-item">
        <a
          href="https://www.gazprom.ru/"
          class="ViewPartners__link"
          target="_blank"
        >
          <img src="/static/images/logos/1.png" alt="" />
        </a>
      </li>
      <li class="ViewPartners__list-item">
        <a href="https://sber.ru/" class="ViewPartners__link" target="_blank">
          <img src="/static/images/logos/2.png" alt="" />
        </a>
      </li>
      <li class="ViewPartners__list-item">
        <a href="https://lukoil.ru/" class="ViewPartners__link" target="_blank">
          <img src="/static/images/logos/3.png" alt="" />
        </a>
      </li>
      <li class="ViewPartners__list-item">
        <a
          href="https://www.tatneft.ru/"
          class="ViewPartners__link"
          target="_blank"
        >
          <img src="/static/images/logos/4.png" alt="" />
        </a>
      </li>
      <li class="ViewPartners__list-item">
        <a
          href="https://www.rosneft.ru/"
          class="ViewPartners__link"
          target="_blank"
        >
          <img src="/static/images/logos/5.png" alt="" />
        </a>
      </li>
      <li class="ViewPartners__list-item">
        <a
          href="https://spimex.com/"
          class="ViewPartners__link"
          target="_blank"
        >
          <img src="/static/images/logos/6.png" alt="" />
        </a>
      </li>
      <li class="ViewPartners__list-item">
        <a
          href="https://www.transneft.ru/"
          class="ViewPartners__link"
          target="_blank"
        >
          <img src="/static/images/logos/7.png" alt="" />
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'ViewScheme',
  components: {},
  props: {},
};
</script>

<style lang="scss">
.ViewPartners {
  @include media-sm('up') {
    padding-bottom: rem(15);
  }
  &__list {
    list-style: none;
    padding: 0;
    margin: rem(-20);
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: center;
    @include media-sm {
      margin: rem(-10);
    }
  }
  &__list-item {
    flex-grow: 1;
    max-width: 14%;
    @include media-md {
      max-width: 20%;
    }
    @include media-sm {
      max-width: 25%;
    }
    @include media-xs {
      max-width: 35%;
    }
  }
  &__link {
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.6;
    margin: rem(20);
    transition: all 0.2s ease;
    img {
      max-width: 100%;
    }
    @include media-sm {
      margin: rem(10);
    }

    &:hover {
      opacity: 1;
    }
  }
}
</style>
